import { ErrorContainer, LeftWrapper } from "./atom";
import { isFox, isEn } from "project-config/utils/env";
import foxRight from "./images/fox-right.png";
import renderbusRight from "./images/renderbus-right.png";
import { Button } from "task-eva-ui";
import { useEffect } from "react";
import { pageSpyManager } from "project-config/services";
import { getTranslateNsT } from "./i18n";

export function ErrorPage({ userId = undefined }: { userId?: number }) {
  const t = getTranslateNsT(isEn() ? "en" : "zh");

  useEffect(() => {
    if (!userId) return;
    void pageSpyManager.uploadLog({
      userId,
      remark: "auto",
    });
  }, [userId]);

  return (
    <ErrorContainer isFox={isFox}>
      <LeftWrapper>
        <div>
          <p className="title">{t("error_title")}</p>
          <p className="tip">{t("error_tip1")}</p>
          <p className="tip">{t("error_tip2")}</p>
        </div>
        <Button onClick={() => window.location.reload()}>
          {t("error_fresh")}
        </Button>
      </LeftWrapper>
      <img src={isFox ? foxRight : renderbusRight} alt="" />
    </ErrorContainer>
  );
}
